import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  COLLECTIONS_ADD_SINGLE_VALIDATION_RULE_BEGIN,
  COLLECTIONS_ADD_SINGLE_VALIDATION_RULE_SUCCESS,
  COLLECTIONS_ADD_SINGLE_VALIDATION_RULE_FAILURE,
  COLLECTIONS_ADD_SINGLE_VALIDATION_RULE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { toast } from 'react-toastify';

export function addSingleValidationRule(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_ADD_SINGLE_VALIDATION_RULE_BEGIN,
    });

    const { projectId, collectionUuid, validationId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.patch(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/validations/${collectionUuid}/collection/${validationId}`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: COLLECTIONS_ADD_SINGLE_VALIDATION_RULE_SUCCESS,
              data: res.data,
              collectionUuid,
            });
            Mixpanel.track('Added collection validation rule');
            toast.success('Added Rule Successfully !');
            resolve(res);
          } else {
            dispatch({
              type: COLLECTIONS_ADD_SINGLE_VALIDATION_RULE_FAILURE,
              data: { error: 'Failed' },
            });
            Mixpanel.track('Failed to delete collection validation');
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Deletion failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_ADD_SINGLE_VALIDATION_RULE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissAddSingleValidationRuleError() {
  return {
    type: COLLECTIONS_ADD_SINGLE_VALIDATION_RULE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_ADD_SINGLE_VALIDATION_RULE_BEGIN:
      return {
        ...state,
        addSingleValidationRulePending: true,
        addSingleValidationRuleError: null,
      };

    case COLLECTIONS_ADD_SINGLE_VALIDATION_RULE_SUCCESS:
      let projectCollections = state.projectCollections;
      let index = projectCollections.findIndex((item) => {
        return item.uuid === action.collectionUuid;
      });
      if (index !== -1) {
        projectCollections[index].validations = action.data;
      }
      return {
        ...state,
        addSingleValidationRulePending: false,
        addSingleValidationRuleError: null,
        projectCollections,
        selectedCollection: {
          ...state.selectedCollection,
          validations: action.data,
        },
      };

    case COLLECTIONS_ADD_SINGLE_VALIDATION_RULE_FAILURE:
      return {
        ...state,
        addSingleValidationRulePending: false,
        addSingleValidationRuleError: action.data.error,
      };

    case COLLECTIONS_ADD_SINGLE_VALIDATION_RULE_DISMISS_ERROR:
      return {
        ...state,
        addSingleValidationRuleError: null,
      };

    default:
      return state;
  }
}
